import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "q-ma-lg flex justify-center text-h5",
  style: {"height":"15vh"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Errors:")
const _hoisted_3 = { class: "text-weight-medium" }
const _hoisted_4 = { class: "q-ml-sm" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Payload:")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, { ref: "dialogRef" }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "q-column q-pa-md justify-between",
        style: {"width":"1000px","max-height":"60vh","max-width":"80vw","flex-wrap":"nowrap"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              (_ctx.invoicingExternalLogs.count === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, " No logs found! "))
                : (_openBlock(), _createBlock(_component_q_list, {
                    key: 1,
                    dense: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { class: "col-2 text-h6 full-height text-right text-weight-medium" }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_list, { class: "q-px-lg" }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastEntry.response.errors, (error) => {
                                return (_openBlock(), _createBlock(_component_q_item, {
                                  key: error.field
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_3, _toDisplayString(error.field) + ":", 1),
                                    _createElementVNode("span", _hoisted_4, _toDisplayString(error.message), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_q_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { class: "col-2 text-h6 full-height text-right text-weight-medium" }, {
                            default: _withCtx(() => [
                              _hoisted_5
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_q_item_section, { class: "q-pl-lg q-pt-sm" }, {
                            default: _withCtx(() => [
                              _createElementVNode("pre", null, _toDisplayString(_ctx.lastEntry.payload), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          }),
          _createVNode(_component_q_separator, { class: "q-my-sm" }),
          _createVNode(_component_q_card_actions, { class: "justify-end" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_btn, {
                onClick: _ctx.onDialogCancel,
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}